// The house CARD — every content card paints the branded `card` surface
// (Nika 2026-09-24, Q2 (B)). The rail cards (AppSidebar's children) are the
// AppSidebarCard built on this one: its corner and padding on the brand
// `navbar` glass (Nika 2026-10-30, "A: navbar glass" — AppSidebar.js,
// __tests__/sidebarGlass.test.js). The `card` surface is one fill step above
// the sheet, gray3 dark / gray15 light, with its own ink (brand theme.js
// `card`, the same surface as the admin AdminCard). On the app frame (gray2 /
// gray16) it reads 1.19:1 dark / 1.08:1 light; on the standard stage 1.62 /
// 1.26.
//
// It used to paint the SHEET's own pair (`overlayStrong` dark / `white`
// light): 1.00:1 dark and 1.04:1 light against the frame on 22 admin pages,
// so no card on the sheet could read as a card, and neither could the rail.
// The sheet itself (AppMain) no longer extends this component — it is flat,
// the frame colour, and the sticky PageHeader paints that same colour.
// Guarded by __tests__/commonCardLightGround.test.js.
export const CommonCard = {
  theme: 'card',
  round: 'radiusCard',
  padding: 'A'
}
